/**
 * custom-overlay-theme.js
 * ------------------------
 * Applies the seasonal theme class to the cart drawer, search overlay,
 * and mobile nav drawer based on the "Seasonal overlays" theme settings.
 *
 * Reads window.customOverlayTheme (printed inline from layout/theme.liquid)
 * and adds one of:
 *   .custom-color-inherit-high
 *   .custom-color-inherit-medium
 *   .custom-color-<suite-id>    (when mode === 'custom')
 * plus an optional dark modifier: .dark-mode or .auto-dark.
 *
 * The classes are already defined in snippets/custom-css-variables.liquid
 * and resolve to the drawer semantic tokens. Impulse's drawer vars are
 * bridged to those tokens in the overlay bridge block of the same file.
 *
 * Runs on `page:loaded` per the Impulse lazy-CSS gotcha.
 */
(function () {
  'use strict';

  // Overlay roots that take the full dark/auto suite treatment.
  var OVERLAY_SELECTORS = [
    '#CartDrawer',
    '.site-header__search-container',
    '#NavDrawer'
  ];

  // Elements that should always use the LIGHT variant of the selected suite,
  // even when the overlay root is in dark/auto mode. Keeps the predictive
  // search results panel readable with product thumbnails.
  var LIGHT_OVERLAY_SELECTORS = [
    '#predictive-search'
  ];

  function applyOverlayTheme() {
    var cfg = window.customOverlayTheme;
    if (!cfg) return;

    var suiteId;
    if (cfg.mode === 'custom') {
      // custom_overlay_scheme can come through as an object (color_scheme drop)
      // or a string (legacy/default). Mirror the defensive pattern used in
      // custom-css-variables.liquid.
      suiteId = (cfg.scheme && cfg.scheme.id) || cfg.scheme;
    } else {
      suiteId = cfg.mode; // 'inherit-high' or 'inherit-medium'
    }

    if (!suiteId) return;

    var suiteClass = 'custom-color-' + suiteId;
    var darkClass = '';
    if (cfg.dark === 'dark') darkClass = 'dark-mode';
    else if (cfg.dark === 'auto') darkClass = 'auto-dark';

    OVERLAY_SELECTORS.forEach(function (selector) {
      var el = document.querySelector(selector);
      if (!el) return;
      el.classList.add(suiteClass);
      if (darkClass) el.classList.add(darkClass);
    });

    // Light variant only — no dark modifier — so these elements override
    // inherited dark tokens with the suite's light fields.
    LIGHT_OVERLAY_SELECTORS.forEach(function (selector) {
      var el = document.querySelector(selector);
      if (!el) return;
      el.classList.add(suiteClass);
    });
  }

  // Impulse lazy-loads CSS and dispatches page:loaded when ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyOverlayTheme);
  } else {
    applyOverlayTheme();
  }
  document.addEventListener('page:loaded', applyOverlayTheme);
})();
